module.exports = __webpack_public_path__ + "img/ball_wall_card.6364acad.svg";